










































































































import Vue from "vue";
import { Prop, Watch } from "vue-property-decorator";
import { Component } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { AppConstants as _app } from "@/shared/app.constants";
import { http } from "@/shared/https";
import { Utilities as utils } from "@/shared/utilities";
import AuthService from "@/services/auth.service";
import { User } from "oidc-client";
import AlertpopupComponent from "@/components/common/Alertpopup/Alertpopup.vue";
const auth = new AuthService();

import "@/styles/iucn/filter.css";
import "@/styles/iucn/main-content.css";
import { Workspace, ApplicationSubmit } from "@/entities";
import { Locales } from "@/i18n/locales";

const namespace: string = "application";

@Component({
  components: {
    AlertpopupComponent
  },
})
export default class ProposalCallsFilterComponent extends Vue {
  @State(namespace) application!: Workspace;
  @Action("getApplication", { namespace }) getApplication: any;
  @Action("resetAppState", { namespace }) resetAppState: any;
  @Action("deleteApplication", { namespace }) deleteApplication: any;
  @Action("setApplicationId", { namespace }) setApplication: any;
  @Getter("rootTemplate", { namespace }) schema: any;
  @Getter("_appUser", { namespace: "RootApp" }) _username!: string;
  @Prop() calls!: any;
  @Getter("projectYrs", { namespace: "application" }) years: any;
  @Getter("reportingFrequency", { namespace: "application" }) reportingFreq: any;
  @Getter("appSubmit", { namespace }) appSubmit: ApplicationSubmit;

  userRoles = [];
  auditRoleId = _app.appRoles.Auditor;
  appStatus: any = _app.applicationStatus;
  wfStatus: any = _app.workflowStatusCode;
  editableStatus: any = _app.applicantEdiatableStatus;
  editableStatusCode: any = _app.appicantEditableStatusCode;
  alert=false;
  success=false;
  appInfo="";
  defaultLocale: string = localStorage.getItem("language") || Locales.EN;

  /** mounted fn */
  mounted() {
    auth.getUser().then((user: User) => {
      // handling multiple roles
      if (Array.isArray(user.profile.role_id)) {
        this.userRoles = this.userRoles.concat(user.profile.role_id);
      } else {
        this.userRoles.push(user.profile.role_id);
      }
    });

    this.resetAppState();
  }

  formatCurrency(val, currency) {
    return utils.formatCurrency(val, currency, this.defaultLocale);
  }

  listProposal() {
    return http.get(`/api/Proposal/application/List`).then((resp: any) => {
      return resp.data.Items;
    });
  }

  Ok(data)
  {
     this.rollback(this.appInfo).then(resp=>{
        if(resp)
        {
          this.$emit("rollback",this.appInfo)
          this.appInfo=""
          this.alert=false
        }
      })
      this.appInfo=""
      this.alert=false
  }

  Cancel(data)
  {
    this.alert=false;
  }

  addNewProposal() {
    this.$router.push({
      name: "callForProposal",
    });
  }

  Rollback(appInfo)
  {
    if(!this.alert)
    {
    this.alert=true;
    this.appInfo=appInfo;
    }
  }

  rollback(appInfo)
  {
     return http.post(`/api/Workflow/Rollback/${appInfo.StatusId}/Transaction/${appInfo.ApplicationId}`,{}).then((resp: any) => {
      return resp;
    });
  }

  /** Edit Proposal */
  editProposal(proposalId) {
    if (this.userRoles.includes(_app.appRoles.Auditor)) {
      this.$router.push({
        name: "viewApplication",
        params: { appId: proposalId },
      });
    } else {
      this.$router.push({
        name: "applSummary",
        params: { applicationId: proposalId },
      });
    }
  }

  /** Delete Proposal*/
  deleteProposal(data) {
    // handled in parent
    this.$emit("delete", data);
  }

  download(proposalId) {    
    let self = this;
    const appId =
      typeof proposalId === "string" ? parseInt(proposalId) : proposalId;
    this.getApplication(appId).then((data: any) => {      
      if (data && data.projectTitle) {
        this.generatePdf();
      }
    });
  }
  generatePdf() {
    // const applicationData =this.application.application.BudgetType == 'Tiger' ? { ...this.application.data, amountOfMatchingFund:  this.application.data.applicationBudget.summary.totalBudget.matchFunding || 0 } : this.application.data;
     let applicationData;

switch (this.application.application.BudgetType) {
  case 'Tiger':
    applicationData = {
      ...this.application.data,
      amountOfMatchingFund: this.application.data.applicationBudget.summary.totalBudget.matchFunding || 0
    };
    break;
  case 'CAG':
    applicationData = {
      ...this.application.data,
      fundingRequests: this.application.data.totalProjectBudgect || 0
    };
    break;
  default:
    applicationData = this.application.data;
    break;
}
    this.$services.pdf.generate({
      entity: "Application",
      schema: this.schema,
      data: applicationData,
      currency: this.application.application.BudgetCurrency,
      user: this._username,
      id: this.application.application.ApplicationId,
      code: this.application.application.Code,
      type: this.application.templates["IsRAGTemplate"] ? "RAG" : "TSG",
      years: this.years,
      Quaters: this.reportingFreq,
      "checklist": this.appSubmit.checklist,
      "logSchema": this.application.logSchema
    });
  }
}
